module.exports = __webpack_public_path__ + "img/ic-smart-plus.ea03e63b.svg";